export default __webpack_public_path__ + "static/media/how_to_play_button_image.4036d31f.svg";